import { FormControlLabel, Icon, IconButton, Radio, Snackbar, Typography } from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import mailSend from 'assets/animations/mail-send.json'
import { EmailList } from 'components'
import { useDocumentReportParams } from 'hooks'
import { ROOT_TITLE, SEND_REPORT_TITLE, sendDocumentReportByEmailService, sendDocumentReportSuppliers, transformDocumentReportParams } from 'lib'
import React from 'react'
import { Helmet } from 'react-helmet'
import Lottie from 'react-lottie'

const SendReports = () => {

    const [selected, setSelected] = React.useState<number[]>([])
    const { handleChangeParams, params } = useDocumentReportParams()
    const [open, setOpen] = React.useState(false)
    const toggleSelect = (typeId: number) => {
        setSelected(current => {
            return current.includes(typeId) ? current.filter(c => c !== typeId) : [...current, typeId]
        })
    }

    const [seleccionado, setseleccionado] = React.useState<boolean>(false)

    const onSubmit = async (emails: string[]) => {
        try {
            await sendDocumentReportSuppliers(emails)
        } catch (error) {
            
        }
    }
    return (
        <div className="w-full flex flex-col h-full overflow-hidden">
            <Helmet>
                <title>{`${ROOT_TITLE} - ${SEND_REPORT_TITLE}`}</title>
            </Helmet>
            <div className="flex flex-grow overflow-hidden">
                <div className="flex flex-grow flex-col h-full mr-4 bg-transparent">
                    <Typography className="pb-3 pt-4" color="textSecondary" variant="body2" style={{ fontWeight: 700, letterSpacing: 0.5 }}>
                        {"Reportes Varios"}
                    </Typography>
                    <div className="flex flex-grow flex-col">
                    <div className="flex-grow my-1 pl-4">
                        <FormControlLabel
                            control={
                                <Radio
                                    checked={seleccionado}
                                    size="small"
                                    onClick={()=>{setseleccionado(!seleccionado)}}
                                />
                            }
                            label={
                                <Typography
                                    variant="button"
                                    style={{ letterSpacing: 0.5 }}
                                >
                                    {'Reporte de proveedores'}
                                </Typography>
                            }
                        />
                        </div>
                    </div>
                </div>
                <EmailList
                    reportTypeSelected={Boolean(selected.length)}
                    onSubmit={onSubmit}
                    supplier={seleccionado}
                />
            </div>
            <Snackbar
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={open}
                autoHideDuration={6000}
                onClose={() => setOpen(false)}
                action={
                    <IconButton style={{ marginRight: 20 }} aria-label="close" color="inherit" onClick={() => setOpen(false)}>
                        <Icon>close</Icon>
                    </IconButton>
                }
            >
                <Alert variant="filled" onClose={() => setOpen(false)} severity="info" style={{ paddingRight: 30 }}>
                    <div className="flex items-center">
                        <Lottie
                            options={{
                                loop: true,
                                autoplay: true,
                                animationData: mailSend,
                                rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
                            }}
                            height={120}
                            width={120}
                        />
                        <Typography className="px-4">{"Sus reportes se estan enviando..."}</Typography>
                    </div>
                </Alert>
            </Snackbar>
        </div>
    )
}

export default SendReports
